import React from "react";
import NeoInputText from "./NeoInputText.base";

const NeoInputText_disabled = (props) => {
  return (<>
    <NeoInputText {...props} disabled></NeoInputText>
  </>);
};

export default NeoInputText_disabled;